import {get} from 'lodash';
import {isNil} from 'lodash/fp';

/**
 *This function checks if an alternateItemKey exists. If it does, it gets that key from the item object else it returns the items id.
 * @param {alternateItemKey} string - alternateItemKey field name. In this case 'uniqueId'
 * @returns {function(*): *} - returns a function that gets a key from an object.
 */
export const getKeyExtractor = ({alternateItemKey}: any) => {
  if (!isNil(alternateItemKey)) {
    return (item: any) => item[alternateItemKey];
  }
  return (item: any) => item.id;
};

/**
 * This function get avatarUrl from the object from the props
 * @param {object} params - Parameters
 * @returns {string}
 */
export const getPersonAvatarUrl = (item: any) => get(item, 'avatarUrl', '');

/**
 * This function get accountEmail from the object from the props
 * @param {object} params - Parameters
 * @returns {string | null}
 */
export const getPersonAvatarEmail = (item: any) =>
  get(item, 'accountEmail', null);
export const getOrderReportLevel = (reportHeading: any) => {
  if (reportHeading === 'Frontline Qualifying Volume') {
    return 'frontline';
  }
  if (reportHeading === 'Generation 0 Volume') {
    return 'genZero';
  }
  if (reportHeading === 'Total Generation Volume') {
    return 'allOrg';
  }
  return 'frontline';
};
